export const prerender = true;

// Emit `route/index.html` instead of `route.html`, so the backend can serve
// the build with FastAPI's `app.frontend()` (which resolves directories to
// their `index.html`, but not paths to `.html` files).
export const trailingSlash = 'always';
